import React, { useContext, useEffect, useState } from 'react';
import {
  Currencies,
  CURRENCY,
  get_precision,
  Money,
} from '../../../utils/money';
import {
  FormControl,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Box,
  IconButton,
  Button,
  Autocomplete,
  Alert,
  CircularProgress,
  Tooltip,
  Typography,
} from '@mui/material';
import Decimal from 'decimal.js';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { IArea, ILocation } from '../../../interfaces/common/location';
import AddressInputWithAutocomplete from '../adress-input-with-autocomplete/address-input-with-autocomplete';
import { emptyLocation } from '../../../data/locations';
import Grid2 from '@mui/material/Unstable_Grid2';
import { RegionType, emptyRegion, getGovernorateForDistrict, regions } from '../../../data/regions';
import { isMobile, isTablet } from 'react-device-detect';
import AreaInput from '../city-input/city-input';
import { grey } from '@mui/material/colors';
import { useSnackBar } from '../../../contexts/snackbar';
import { API_ENDPOINT } from '../../../configurations/global.config';
import { AuthContext } from '../../../contexts/user-context/user-context';
import axios from 'axios';
import { AutoAwesome, Info } from '@mui/icons-material';
import { user_is_merchant } from '../../../utils/permissions';
import LebanonMap, { LocationType } from '../lebanon-map/lebanon-map';
import IncompleteAddressError from '../incomplete-address-error/incomplete-address-error';
import { MuiTelInput } from 'mui-tel-input';
import ArabicKeyboard from '../arabic-keyboard';
import TextFieldWithArabicKeyboard from '../text-field-with-arabic-keyboard';

interface LocationsInputProps {
  locations: ILocation[];
  setLocations: (locations: ILocation[]) => void;
  label: string;
  icon?: React.ReactNode;
}

function LocationsInput({
  locations,
  setLocations,
  label,
  icon,
}: LocationsInputProps) {

  const {showMessage} = useSnackBar();
  const { config } = useContext(AuthContext);
  const [loadingAIResponseFor, setLoadingAIResponseFor] = useState<number | null>(null);
  const [showArabicKeyboardFor, setShowArabicKeyboardFor] = useState<number | null>(null);


   const resolveAddress = async (index: number) => {
        const address = locations[index].directions ?? ""
        try {
          setLoadingAIResponseFor(index);
          const endpoint = `${API_ENDPOINT}/api/v1/resolve-address/?address=${encodeURIComponent(address)}`
          const response = await axios.get<IArea>(endpoint, config);

          showMessage("Address resolved successfully!")
          
          const newLocations = [...locations]
          newLocations[index].area = response.data
          setLocations(newLocations)
          } catch(e) {
          showMessage("We could not detect area :(", 'error')
        } finally{
          setLoadingAIResponseFor(null)
        }
    }

  console.log("locations = ", locations)

  const handleUpdateLocations = (
    index: number,
    newArea: IArea | undefined,
    newDirections: string,
    newUrl: string,
    newPlaceID: string,
    newPhoneNumber: string,
  ) => {
    const newLocations = locations.map((item, item_index) => {
      return index === item_index
        ? {
            ...item,
            area: newArea,
            directions: newDirections,
            url: newUrl,
            place_id: newPlaceID,
            phone_number: newPhoneNumber
          }
        : item;
    });

    setLocations(newLocations);
  };

  console.log('Locations = ', locations);
  return ( 
    <Box
      component="div"
      sx={{
        padding: 2,
        borderRadius: 2,
        
        height: '100%',
      }}
    >
      <legend
        style={{
          padding: 3,
          color: '#888',
          fontWeight: 'bold',
          textAlign: 'center',
        }}
      >
        {icon ? (
          <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {icon}
            {label}
          </span>
        ) : (
          <p>{label}</p>
        )}
      </legend>

      {/* Render all location inputs */}
      {locations.map((item, index) => (
        <Box
          key={label}
          sx={{
            mb: 3,
            p: 2,
            borderRadius: 2,
            backgroundColor: item.id != '' ? grey[50] : '',
            border: '1px solid #ddd',
            boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
            position: 'relative', // <-- Important!
          }}
        >
          <IconButton
            size="small"
            onClick={() =>
              setLocations(
                locations.filter((_, loc_index) => loc_index !== index)
              )
            }
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              color: 'gray',
              '&:hover': {
                color: 'red',
              },
            }}
          >
            <DeleteIcon fontSize="medium" />
          </IconButton>

          <Box
            sx={{
              fontWeight: 'bold',
              color: '#666',
              mb: 2,
              fontSize: '1rem',
            }}
          >
            📍 Location #{index + 1}
          </Box>
          {
          item.id && !item.area && <IncompleteAddressError />
          }
          
          <Grid2 container spacing={0} >

            <Grid2 xs={12} md={8}>
              <>
                          {locations[index].directions.length > 0 && <div >
                <IconButton disabled={loadingAIResponseFor!=null}>
                  {loadingAIResponseFor == index ?<CircularProgress size={23} />: <AutoAwesome onClick={()=>resolveAddress(index)} color="primary"/> }
              </IconButton> 
                  <Tooltip sx={{ml: 2}} title="Fill the directions with as much detail as possible, then click the magic icon on the left to detect the city and district with the help of AI.">
                            <span>Detect city and district with AI ⭐ (Trial)</span>
                  </Tooltip>         
            </div>}
           
            <br />
          {item.id !== '' && (
            <Grid2 xs={12}>
              <Box mt={1}>
                <Alert severity="info" variant="outlined">
                  Modifying or deleting this location will <b><u>NOT</u></b> impact orders linked to it.
                </Alert>
                <br />
              </Box>
            </Grid2>
          )}
              <AreaInput
                area={item.area ?? null}
                setArea={(c) =>
                  handleUpdateLocations(
                    index,
                    c ?? undefined,
                    item.directions,
                    item.url,
                    item.place_id,
                    item.phone_number
                  )
                }
              />
              <br />
              <br />
              <TextFieldWithArabicKeyboard
                autoComplete="off"
                fullWidth
                multiline
                value={item.directions}
                label={'Directions'}
                InputProps={{minRows: 4}}
                onChange={(v) =>
                  handleUpdateLocations(
                    index,
                    item.area,
                    v,
                    item.url,
                    item.place_id,
                    item.phone_number
                  )
                }
              />


            </>
            </Grid2>
            <Grid2 xs={12} md={4}>
                    <LebanonMap 
                        locations={[{
                          area: item.area,
                          id: item.area?.code ?? "",
                          label: item.area?.name_en ?? "No Name",
                          type: LocationType.GENERIC
                        }]}
                        width={200}
                        height={250}
                        showPartitions={false}
                        useStaticMap
                     />
            </Grid2>
          </Grid2>
        </Box>
      ))}

      {/* "Add More" Button below the inputs */}
      <Box sx={{ textAlign: 'center', display: 'absolute', bottom: 0 }}>
        <Button
          size={(isMobile && !isTablet) ? 'small' : 'medium'}
          variant="outlined"
          color="primary"
          onClick={() => {
            setLocations([...locations, emptyLocation]);
          }}
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 500000,
          }}
        >
          <AddIcon />
        </Button>
      </Box>
    </Box>
  );
}

export default LocationsInput;
